import React from "react";
import { TableRow, TableCell, styled } from "@mui/material";
import { QueuedReportAllColumnKeys, ReportHistoryAllColumnKeys } from "./QueuedReportListTypes";
import { ModerationReportViewMode } from "../../../types/Constants";

const TableHeaderRow = styled(TableRow)(({ theme }) => {
  return {
    "& th": {
      fontSize: 14,
      padding: 8,
      fontWeight: 500,
      color: theme.palette.text.primary,
      "&:first-of-type": {
        paddingLeft: 20,
      },
      "&:last-of-type": {
        paddingRight: 20,
      },
    },
  };
});

interface QueuedReportListHeadingProp {
  viewMode: string;
}

const QueuedReportListHeading: React.FC<QueuedReportListHeadingProp> = ({ viewMode }) => {

  const columns = (viewMode === ModerationReportViewMode.Queue) ? QueuedReportAllColumnKeys : ReportHistoryAllColumnKeys;

  return (
    <TableHeaderRow>
      {
        columns.map((value: string) => (
          <TableCell key={value} align="left">
            {value}
          </TableCell>
        ))
      }
    </TableHeaderRow>
  );
};

export default QueuedReportListHeading;
